import React, { useState } from 'react'
import styles from './Accordion.module.scss'
import ArrowIcon from 'shared/assets/icons/Accordion/ArrowIcon'
import classNames from 'classnames'

interface AccordionItemProps {
  title: string
  content: string
  isActive: boolean
  onToggle: () => void
}

const AccordionItem: React.FC<AccordionItemProps> = ({ title, content, isActive, onToggle }) => {
  return (
    <div className={styles.accordion__item} onClick={onToggle}>
      <div className={styles.accordion__header}>
        <h3>{title}</h3>
        <span className={classNames(styles.accordion__toggle, {
          [styles.accordion__toggle_active]: isActive,
        })}>
          <ArrowIcon />
        </span>
      </div>
      {isActive && <div className={styles.accordion__content}>{content}</div>}
    </div>
  )
}

interface AccordionProps {
  items: { title: string; content: string }[]
}

const Accordion: React.FC<AccordionProps> = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null)

  const toggleItem = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <div className={styles.accordion}>
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          content={item.content}
          isActive={activeIndex === index}
          onToggle={() => toggleItem(index)}
        />
      ))}
    </div>
  )
}

export default Accordion
